import type { KarlCustomPayload } from "@/components/document-chat/services/streamEventTypes";
import { KarlEventContent, ProcessingNode, StreamPhase } from "@/constants/enums";
import type { DocumentChatRuntime } from "../types";

/**
 * Handles FETCH_CONTEXT events for context retrieval phase
 *
 * @param payload - The fetch context event payload
 * @param runtime - The document chat runtime store interface
 */
export function handleFetchContextEvent(
  payload: KarlCustomPayload,
  runtime: DocumentChatRuntime
): void {
  const c = String(payload.content ?? "").toUpperCase();
  if (c === KarlEventContent.START) {
    runtime.update({ phase: StreamPhase.THINKING, currentNode: ProcessingNode.CONTEXT_RETRIEVER });
  } else if (c === KarlEventContent.FINISHED) {
    // Context retrieval complete - mark processing stages as complete
    // Keep currentNode as ContextRetriever so the UI stays visible with all checkmarks
    runtime.update({ processingStagesComplete: true });
  }
}
